import { useState, useEffect } from "react";
import { translate } from "../../translations";
import APIclient from "../../api-client";
import { ContentBlock, StaticPage, Stored } from "../../types";
import ContentBlockComponent from "../../components/content_block";

export default function About() {
  const [blocks, setBlocks] = useState<Array<Stored<ContentBlock>>>([]);

  useEffect(() => {
    APIclient.contentBlocks.index(StaticPage.About).then(setBlocks);
  }, []);

  return (
    <>
      <h1 className="page__title">
        <span className="--highlighted">
          {translate("general_about_title")}
        </span>
      </h1>
      <section className="static-content">
        {blocks.map((block) => (
          <ContentBlockComponent block={block} key={block._id} />
        ))}
      </section>
    </>
  );
}
